export default __webpack_public_path__ + "static/media/iconSoporte.49ee7149.svg";